/* Each footer owns its observers and listeners, including Theme Editor re-renders. */
(() => {
  'use strict';
  const controllers = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    if (controllers.has(root)) return;
    const scene = root.querySelector('[data-family-scene]');
    const ball = root.querySelector('[data-family-ball]');
    const cta = root.querySelector('.final__bubble');
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let visible = false;
    let timer;
    const motionOff = () => root.dataset.motion === 'false' || reducedMotion.matches || window.Lagom?.motionOff?.();
    const refresh = () => {
      const paused = motionOff() || document.hidden;
      scene.classList.toggle('is-visible', visible);
      scene.classList.toggle('is-paused', Boolean(paused));
      ball.disabled = Boolean(motionOff());
      if (paused || !visible) {
        clearTimeout(timer);
        scene.classList.remove('is-playing');
      }
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      refresh();
    }, { threshold: 0.04 }) : null;
    if (observer) observer.observe(root);
    else visible = true;
    document.addEventListener('visibilitychange', refresh, options);
    reducedMotion.addEventListener('change', refresh, options);
    ball.addEventListener('click', () => {
      if (motionOff()) return;
      clearTimeout(timer);
      scene.classList.add('is-playing');
      timer = setTimeout(() => scene.classList.remove('is-playing'), 4500);
    }, options);
    cta?.addEventListener('pointermove', event => {
      if (motionOff() || event.pointerType === 'touch') return;
      const rect = cta.getBoundingClientRect();
      cta.style.setProperty('--mx', (100 * (event.clientX - rect.left) / rect.width) + '%');
      cta.style.setProperty('--my', (100 * (event.clientY - rect.top) / rect.height) + '%');
    }, options);
    cta?.addEventListener('pointerleave', () => {
      cta.style.removeProperty('--mx');
      cta.style.removeProperty('--my');
    }, options);
    refresh();
    controllers.set(root, () => {
      clearTimeout(timer);
      observer?.disconnect();
      abort.abort();
      controllers.delete(root);
    });
  }
  document.querySelectorAll('[data-family-footer]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-family-footer]').forEach(mount);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-family-footer]').forEach(root => controllers.get(root)?.());
  });
})();

